<template>
  <VContainer>
    <VRow justify="center">
      <VCol cols="12" md="8">
        <VCard elevation="1" class="pa-3 pa-md-7 px-md-12 mb-5">
          <p align="center">
            <strong>Пользовательское соглашение {{ APP_NAME }}</strong>
          </p>
          <p>
            Настоящее Пользовательское соглашение регулирует отношения по использованию
            сайта <a :href="`https://${HOME_DOMAIN}/`">https://{{ HOME_DOMAIN }}/</a>.
          </p>
          <p align="center">
            <strong>1. Общие положения</strong>
          </p>
          <p>
            1.1. Для целей настоящего Пользовательского соглашения, термины и определения
            имеют следующее значение:
          </p>
          <p>
            <strong>Соглашение </strong>
            – настоящее «Пользовательское соглашение {{ APP_NAME }}», размещенное в сети
            Интернет по адресу:
            <a :href="`https://${HOME_DOMAIN}/`">https://{{ HOME_DOMAIN }}/</a>.
          </p>
          <p>
            <strong>Администрация Сайта </strong>
            – ООО "Бозон", являющееся администратором Сайта.
          </p>
          <p>
            <strong>Сайт</strong>
            – принадлежащая Администрации Сайта информационная система, состоящая из
            совокупности графических и информационных материалов, а также программного
            кода и баз данных, обеспечивающих доступность таких материалов в сети Интернет
            по адресу: <a :href="`https://${HOME_DOMAIN}/`">https://{{ HOME_DOMAIN }}/</a>.
          </p>
          <p>
            <strong>Сервисы</strong>
            – функциональные возможности, инструменты, услуги, доступные для Пользователя
            на Сайте, включая Виджет.
          </p>
          <p>
            <strong>Пользователь</strong>
            – лицо, обладающее полной дееспособностью, использующее сервисы Сайта либо
            получившее доступ к Сайту в любой форме.
          </p>
          <p>
            <strong>Стороны </strong>
            – Администрация Сайта и Пользователь при совместном упоминании.
          </p>
          <p>
            <strong>HR</strong>
            – Пользователь, использующий Сайт с целью поиска работников.
          </p>
          <p>
            <strong>Кандидат </strong>
            – лицо, разместившее информацию о себе, включая контактную информацию, с целью
            поиска работы (трудоустройства либо выполнения работ/оказания услуг на ином
            законном основании) либо Пользователь, который проходит Интервью с помощью
            Сервисов Сайта.
          </p>
          <p>
            <strong>Интервью</strong>
            – онлайн собеседование Кандидата с HR; очное
            собеседование, записанное с помощью Сервисов Сайта либо видеозапись с
            ответами, записанная Кандидатом без участия HR.
          </p>
          <p>
            <strong>Личный кабинет</strong>
            – персональный раздел Пользователя на Сайте, в котором Пользователю доступно
            управление отдельными сервисами.
          </p>
          <p>
            <strong>Учетные данные</strong>
            – уникальный логин и пароль, используемые для доступа в Личный кабинет.
          </p>
          <p>
            <strong>Контент </strong>
            – информация, представленная в текстовом, графическом, аудиовизуальном
            форматах на Сайте, являющаяся его наполнением.
          </p>
          <p>
            <strong>Виджет</strong>
            – совокупность программного обеспечения, содержащая модуль записи Интервью,
            устанавливаемая путем внедрения специального программного кода на страницы
            внешнего сайта с целью предоставления возможности Кандидатам осуществлять
            запись Интервью.
          </p>
          <p>
            <strong>Приглашение на интервью</strong>
            – Сервис Сайта, позволяющий HR отправить Кандидату приглашение пройти
            интервью.
          </p>
          <p>
            1.2. Для целей настоящего Соглашения термины и определения в единственном
            числе относятся также и к терминам и определениям во множественном числе.
          </p>
          <p>
            1.3. Везде, где по тексту Соглашения упоминаются «дни», имеются в виду
            календарные дни, если Соглашением прямо не предусмотрено иное.
          </p>
          <p>
            1.4. В случае использования в настоящем Соглашении терминов, не определенных
            выше, определение таких терминов производится в соответствии с текстом
            Соглашения. При отсутствии однозначного определения термина в тексте
            Соглашения Стороны руководствуются законодательством Российской Федерации.
          </p>
          <p>
            1.5. Предложение о заключении Соглашения является бессрочным и действует в
            течение всего времени размещения текста Соглашения на Сайте.
          </p>
          <p>
            1.6. Каждая из Сторон гарантирует, что обладает необходимой право- и
            дееспособностью, а равно всеми правами и полномочиями, необходимыми и
            достаточными для заключения и исполнения Соглашения.
          </p>
          <p>
            1.7. Настоящим Пользователь подтверждает, что акцепт (совершение действий по
            принятию оферты) равносилен подписанию и заключению Соглашения на условиях,
            изложенных в настоящем документе.
          </p>
          <p>
            1.8. Акцептом оферты является полное и безоговорочное принятие оферты
            Пользователем путем совершения одного из следующих действий:
          </p>
          <p>
            1.8.1. использование сервисов Сайта;
          </p>
          <p>
            1.8.2. регистрация на Сайте;
          </p>
          <p>
            1.8.3. авторизация в Личном кабинете;
          </p>
          <p>
            1.8.4. просмотр Контента;
          </p>
          <p>
            1.8.5. заполнение форм на Сайте;
          </p>
          <p>
            1.8.6. иное использование Сайта.
          </p>
          <p>
            1.9. Пользователь должен ознакомиться с действующей редакцией Соглашения до
            начала использования Сайта.
          </p>
          <p>
            1.10. Осуществляя доступ к Сайту, Пользователь в соответствии с Федеральным
            законом от 13 марта 2006 г. N 38-ФЗ «О рекламе» выражает свое согласие на
            получение всей рекламной информации, размещенной на Сайте, в том числе,
            третьими лицами. Пользователь понимает и соглашается, что Сайт не определяет
            содержание и не несет ответственности за такую информацию, включая
            веб-ресурсы, ссылки на которые могут содержаться в соответствующих материалах.
          </p>
          <p align="center">
            <strong>2. Предмет Соглашения</strong>
          </p>
          <p>
            2.1. Администрация Сайта предоставляет Пользователю право использовать Сайт
            (включая Сервисы Сайта) по прямому назначению, в том числе, путем
            осуществления доступа к Сайту на условиях безвозмездной простой
            (неисключительной) лицензии, на срок, в течение которого Сайт остается
            доступным для Пользователя.
          </p>
          <p>
            2.2. Доступ к отдельным Сервисам осуществляется за плату в соответствии с условиями,
            установленными разделом "Тарифы" в Личном  кабинете Пользователя.
          </p>
          <p align="center">
            <strong>3. </strong>
            <strong>Регистрация на Сайте</strong>
          </p>
          <p>
            3.1. Для организации взаимодействия с Пользователем, а также для возможности
            использования отдельных Сервисов Администрация Сайта предоставляет возможность
            регистрации в Личном кабинете.
          </p>
          <p>
            3.2. Регистрация Пользователя на Сайте является бесплатной и добровольной.
          </p>
          <p>
            3.3. Администрация Сайта регистрирует Личный кабинет Пользователя в следующем
            порядке: используя специальную форму, Пользователь указывает фамилию, имя,
            e-mail (логин), пароль и номер телефона.
          </p>
          <p>
            3.4. Администрация Сайта оставляет за собой право устанавливать требования к
            паролю (длина, допустимые символы).
          </p>
          <p>
            3.5. Регистрация учетной записи осуществляется на один e-mail/номер телефона
            Пользователя однократно.
          </p>
          <p>
            3.6. Пользователь несет ответственность за достоверность, актуальность,
            полноту и соответствие законодательству предоставленной информации при
            регистрации.
          </p>
          <p>
            3.7. Администрация Сайта вправе потребовать от Пользователя подтверждения
            указанных при регистрации данных, а также запросить подтверждающие документы
            (в т.ч. документы, удостоверяющие личность).
          </p>
          <p>
            3.8. Администрация Сайта вправе заблокировать или удалить учетную запись
            Пользователя, а также прекратить или ограничить доступ Пользователя к
            определенным Сервисам Сайта, в случае предоставления Пользователем
            недостоверных данных, непредоставления подтверждающих документов, а также при
            нарушении Пользователем иных условий настоящего Соглашения.
          </p>
          <p>
            3.9. Пользователь обязан следить за сохранностью своих Учетных данных. Любое
            действие, совершенное из Личного кабинета Пользователя с использованием его
            Учетных данных, считается действием, совершенным самим Пользователем и
            устанавливает обязанности и ответственность для Пользователя в отношении таких
            действий, включая ответственность за нарушение настоящего Соглашения и
            требований законодательства.
          </p>
          <p>
            3.10. Пользователь не имеет права использовать для доступа на Сайт Учетные
            данные другого Пользователя.
          </p>
          <p>
            3.11. Пользователь, доступ которого к Сервисам был прекращен, не имеет права
            создавать новую учетную запись на Сайте без особого разрешения Администрации
            Сайта.
          </p>
          <p>
            3.12. Просмотр информации, размещенной на Сайте в открытом доступе, не требует
            регистрации и/или авторизации Пользователя, однако при совершении таких
            действий Пользователь в любом случае обязан соблюдать положения настоящего
            Соглашения.
          </p>
          <p align="center">
            <strong>4. Использование Сервисов Сайта</strong>
          </p>
          <p>
            4.1. Принимая условия настоящего Соглашения, Пользователь подтверждает и
            гарантируете, что использование Сервисов будет осуществляться Пользователем
            исключительно для целей поиска работы или подбора персонала, с соблюдением
            положений Соглашения и законодательства РФ.
          </p>
          <p>
            4.2. Администрация Сайта предоставляет Кандидату возможность бесплатного
            создания и размещения Интервью на Сайте в ответ на Приглашение на интервью от
            HR.
          </p>
          <p>
            4.3. Создание и размещение осуществляется путем сохранения Интервью в общей
            базе данных Сайта, доступной только Администрации Сайта, и его отображения в
            Личном кабинете HR, направившего приглашение, посредством использования
            Сервиса «Приглашение на интервью» или других Сервисов Сайта.
          </p>
          <p>
            4.4. Кандидат соглашается с тем, что HR, для которого он создал и разместил
            Интервью, может сохранить Интервью для последующего просмотра вне Сайта
            посредством скачивания в память ЭВМ или в любое другое хранилище, а также
            посредством отправки Интервью себе на электронную почту или иным образом с
            помощью функции «поделиться». В таком случае HR обязуется не использовать
            функцию «поделиться» для распространения Интервью среди неограниченного круга
            лиц/для предоставления третьим лицам, и несет ответственность за
            конфиденциальность данных, содержащихся в Интервью.
          </p>
          <p>
            4.5. Кандидат имеет право в любое время без объяснения причины закрыть доступ
            и/или удалить размещенное им Интервью с Сайта.
          </p>
          <p>
            4.6. В качестве имени автора при размещении Интервью на Сайте будет
            указываться имя Кандидата, которое он указал при регистрации на Сайте.
          </p>
          <p>
            4.7. Права на все размещенные на Сайте Интервью считаются принадлежащими
            разместившим их Кандидатами (авторами Интервью) до тех пор, пока не будет
            оснований считать иначе.
          </p>
          <p>
            4.8. Пользователи Сайта не получают никаких прав на использование Интервью
            других Пользователей вне рамок возможностей, предоставляемых Сайтом, если иное
            не разрешено самим Пользователем, и несут полную ответственность перед автором
            за неправомерное использование Интервью.
          </p>
          <p>
            4.9. Пользователь самостоятельно несет ответственность перед третьими лицами
            за свои действия, связанные с созданием и размещением Интервью на Сайте, в том
            числе за то, что содержание Интервью соответствует требованиям
            законодательства РФ и не нарушает права и законные интересы третьих лиц.
            Интервью в целом и каждый из его элементов не должны нарушать интеллектуальные
            права, права на товарные знаки, средства индивидуализации и/или права на иные
            объекты интеллектуальной собственности, принадлежащие третьим лицам.
            Пользователь самостоятельно и за свой счет обязуется урегулировать все
            претензии третьих лиц, связанные с созданием и размещением Интервью на
            Сайте.
          </p>
          <p>
            4.10. Администрация Сайта имеет право без уведомления Пользователя и без
            объяснения причин не принимать Интервью к размещению на Сайте либо в любое
            время удалить Интервью с Сайта.
          </p>
          <p align="center">
            <strong>5. Права и обязанности Сторон</strong>
          </p>
          <p>5.1. <strong>Администрация Сайта обязуется:</strong></p>
          <p>
            5.1.1. Предоставлять информацию по вопросам работы с Сайтом посредством
            электронной почты, а также через службу поддержки Сайта.
          </p>
          <p>
            5.1.2. Воздерживаться от каких-либо действий, способных затруднить
            осуществление Пользователем предоставленного ему права использования Сайта в
            установленных Соглашением пределах.
          </p>
          <p>
            5.1.3. В течение 30 дней со дня получения соответствующего письменного
            уведомления от Пользователя и доказательств нарушения, удалить с Сайта
            материалы, запрещенные к распространению законодательством РФ либо нарушающие
            авторские права.
          </p>
          <p>
            5.2. <strong>Пользователь обязуется:</strong>
          </p>
          <p>
            5.2.1. Использовать Сайт только в пределах тех прав и теми способами, которые
            предусмотрены в Соглашении.
          </p>
          <p>
            5.2.2. Не представляться чужим именем и не регистрироваться, используя чужие
            Учетные данные.
          </p>
          <p>
            5.2.3. Предоставлять по запросу Администрации Сайта документы и информацию,
            необходимые для идентификации Пользователя как стороны Соглашения, а также
            достоверность иных сведений, представленных Пользователем.
          </p>
          <p>
            5.2.4. Уведомлять в течение 3 (трех) рабочих дней Администрацию Сайта в случае
            изменения каких-либо данных о нем, предоставленных Администрации Сайта. В
            случае неисполнения этой обязанности ответственность за все возникшие
            последствия в полном объеме несет Пользователь.
          </p>
          <p>
            5.2.5. Незамедлительно информировать Администрацию Сайта обо всех ставших ему
            известных фактах противоправного использования Сайта третьими лицами.
          </p>
          <p>
            5.2.6. Использовать Сайт, не нарушая имущественных и/или личных
            неимущественных прав третьих лиц, а равно запретов и ограничений,
            установленных применимым правом, включая авторские и смежные права, права на
            товарные знаки, знаки обслуживания, права на использование изображений
            граждан.
          </p>
          <p>
            5.2.7. Не использовать информацию о телефонах, почтовых адресах, адресах
            электронной почты, любую другую персональную информацию для целей иных, нежели
            тематика Сайта (поиск работы и сотрудников).
          </p>
          <p>5.3. <strong>Администрация Сайта вправе:</strong></p>
          <p>
            5.3.1. Собирать информацию о способах использования Сайта (наиболее часто
            используемые функции, настройки, предпочитаемое время и продолжительность
            работы с Сайтом), для улучшения работы Сайта, диагностики и профилактики сбоев
            Сайта.
          </p>
          <p>
            5.3.2. Вносить в одностороннем порядке изменения в Соглашение путем издания
            его новых редакций.
          </p>
          <p>
            5.3.3. Временно прекращать работу Сайта, а равно частично ограничивать или
            полностью прекращать доступ к Сайту до завершения необходимого технического
            обслуживания и (или) модернизации Сайта. Пользователь не вправе требовать
            возмещения убытков за такое временное прекращение оказания услуг или
            ограничение доступности Сайта.
          </p>
          <p>
            5.3.4. Для целей исполнения настоящего Соглашения обрабатывать персональные
            данные Пользователя, предоставленные им, в соответствии Политикой
            конфиденциальности, являющейся приложением к настоящему Соглашению.
          </p>
          <p>
            5.3.5. В случае выявления нарушений приостановить или прекратить доступ
            Пользователя к отдельным Сервисам, включая блокирование доступа к Личному
            кабинету, а также удалить резюме и/или Интервью или отказать в его размещении.
          </p>
          <p>
            5.3.6. В любое время по своему усмотрению без объяснения причин удалять любую
            информацию, размещенную Пользователем на Сайте, которая, по мнению
            Администрации Сайта, нарушает и/или может нарушить законодательство, условия
            настоящего Соглашения, права других Пользователей Сайта или третьих лиц.
          </p>
          <p>5.4. <strong>Пользователь вправе:</strong></p>
          <p>
            5.4.1. Использовать Сайт в пределах и способами, предусмотренными Соглашением.
          </p>
          <p>
            5.4.2. Пользоваться службой поддержки, направляя через интерфейс Сайта
            соответствующие обращения.
          </p>
          <p>
            5.4.3. Пользоваться иными правами, предоставленными ему Соглашением и
            законодательством Российской Федерации.
          </p>
          <p align="center">
            <strong>6. </strong>
            <strong>Интеллектуальная собственность </strong>
            <strong>и порядок использования Сайта</strong>
          </p>
          <p>
            6.1. При условии выполнения Пользователем Соглашения, Пользователю
            предоставляется простая (неисключительная) лицензия на использование Сайта с
            помощью персонального компьютера, мобильного телефона или другого устройства,
            в объеме и порядке, установленном Соглашением, без права продажи,
            предоставления сублицензий и переуступки.
          </p>
          <p>
            6.2. Сайт содержит результаты интеллектуальной деятельности, принадлежащие
            Администрации Сайта.
          </p>
          <p>
            6.3. Используя Сайт, Пользователь признает и соглашается с тем, что все
            содержимое Сайта, и структура содержимого Сайта защищены авторским правом и
            другими правами на результаты интеллектуальной деятельности, и что указанные
            права являются действительными и охраняются во всех формах. Все объекты,
            доступные при помощи Сайта и его Сервисов, включая, помимо прочего, текстовые
            и графические материалы, программы, базы данных, логотипы, товарные знаки
            являются объектами исключительных прав Администрации Сайта и других
            правообладателей и не могут быть использованы иным образом без
            предварительного разрешения правообладателя, если на странице Сайта,
            содержащей такую информацию, явно не указано обратное. Под использованием
            подразумеваются, в том числе: воспроизведение, копирование, переработка,
            распространение на любой основе, отображение во фрейме и т.д.
          </p>
          <p>
            6.4. Право на использование доменного имени {{ APP_NAME }}, включая все уровни
            указанного домена, принадлежит Администрации Сайта.
          </p>
          <p>
            6.5. В соответствии с условиями Соглашения Администрация Сайта предоставляет
            Пользователю право использования Сайта следующими способами:
          </p>
          <p>
            · Использовать Сайт для просмотра, ознакомления с Контентом, реализации иного
            функционала Сайта, в том числе, путем воспроизведения на мониторе (экране)
            соответствующего устройства Пользователя;
          </p>
          <p>
            · Загружать в оперативную память устройства для целей использования Сайта.
          </p>
          <p>
            6.6. Без ущерба для универсального характера положений, изложенных в п. 6.3,
            во избежание сомнений, Пользователю запрещается:
          </p>
          <p>
            · Адаптировать, модифицировать или иным образом перерабатывать программную
            часть Сайта, в том числе, осуществлять перевод на другие языки;
          </p>
          <p>
            · Использовать программные средства (скрипты, роботы) для считывания
            информации с Сайта;
          </p>
          <p>
            · Нарушать целостность защитной системы или осуществлять какие-либо действия,
            направленные на обход, снятие или деактивацию технических средств защиты;
            использовать какие-либо программные коды, предназначенные для искажения,
            удаления, повреждения, имитации или нарушения целостности Сайта, передаваемой
            информации или протоколов;
          </p>
          <p>
            · Использовать информацию, полученную на Сайте для использования
            противоречащим закону способом.
          </p>
          <p>
            6.7. Любое использование принадлежащих Администрации Сайта авторских
            материалов с не допускается без письменного согласия Администрации Сайта.
          </p>
          <p>
            6.8. Не допускается внесение каких-либо изменений и/или дополнений в авторские
            материалы, запрещена любая переработка авторских материалов.
          </p>
          <p align="center">
            <strong>7. Пользовательский контент</strong>
          </p>
          <p>
            7.1. Администрация Сайта предоставляет возможность Пользователю загружать на
            Сайт Пользовательский Контент (Интервью, фотографии и другие материалы).
          </p>
          <p>
            7.2. Пользователь гарантирует, что является обладателем исключительных прав на
            данную фотографию либо иным законным правообладателем.
          </p>
          <p>
            7.3. Принимая условия настоящего Соглашения, Пользователь предоставляет
            Администрации Сайта простую (неисключительную) безвозмездную лицензию на
            Пользовательский контент.
          </p>
          <p>
            7.4. Указанная простая (неисключительная) лицензия на использование
            Пользовательского контента предоставляется Администрации Сайта одновременно с
            добавлением Пользователем Контента на Сайт на весь срок действия
            исключительных прав на объекты авторских и/или смежных прав, образующих такой
            Контент, для использования на территории всех стран мира. В рамках указанной
            лицензии Администрации Сайта предоставляется право на воспроизведение
            Контента; распространение; публичный показ; доведение до всеобщего сведения;
            право на переработку и сублицензирование.
          </p>
          <p>
            7.5. При отсутствии в составе Пользовательского контента объектов
            интеллектуальных прав, Пользователь предоставляет Администрации Сайта входящие
            в состав Контента сведения и прочие информационные материалы для использования
            любым способом, включая право осуществлять запись, систематизацию, накопление,
            хранение, уточнение (обновление, изменение), извлечение, использование,
            обезличивание, блокирование, удаление, уничтожение таких данных, передачу
            (распространение, предоставление третьим лицам).
          </p>
          <p>
            7.6. Пользователь понимает, что Администрация Сайта лишь предоставляет
            Пользователю возможность размещения Пользовательского Контента. Пользователь
            несет всю полноту ответственности за соответствие содержания размещаемого
            Пользователем Контента требованиям законодательства.
          </p>
          <p>
            7.7. Пользователь имеет ясное представление о том, что Администрация Сайта
            имеет право по своему усмотрению отказать Пользователю в размещении им
            Контента или удалить этот Контент.
          </p>
          <p>
            7.8. Пользователю запрещается размещать на Сайте информацию, которая:
          </p>
          <p>
            7.8.1. нарушает авторские и смежные права
          </p>
          <p>
            7.8.2. содержит спам;
          </p>
          <p>
            7.8.3. противоречит общепризнанным нормам морали, порочит честь и достоинство
            или деловую репутацию или нарушают неприкосновенность частной жизни третьих
            лиц;
          </p>
          <p>
            7.8.4. содержит угрозы, нецензурную лексику, порнографические материалы; сцены
            насилия, жестокого обращения с животными; описание средств и способов суицида;
            экстремистские материалы; пропагандируют преступную деятельность или содержат
            советы, инструкции или руководства по совершению преступных действий;
          </p>
          <p>
            7.8.5. пропагандирует и/или способствует разжиганию расовой, религиозной,
            этнической ненависти или вражды, пропагандирует фашизм или идеологию расового
            превосходства;
          </p>
          <p>
            7.8.6. содержит пропаганду наркотических средств, психотропных веществ,
            алкоголя;
          </p>
          <p>
            7.8.7. включает компьютерные коды, предназначенные для нарушения, уничтожения
            либо ограничения функциональности Сайта, любого компьютерного или
            телекоммуникационного оборудования, а также программ;
          </p>
          <p>
            7.8.8. содержит неправомерно используемую личную информацию третьих лиц
            (включая, но не ограничиваясь, упоминание любых адресов и телефонных номеров
            либо иных персональных; нарушает права и интересы граждан и юридических лиц
            или требования законодательства Российской Федерации.
          </p>
          <p>
            7.9. Использование резюме/Интервью, описаний вакансий недопустимо ни с какими
            целями, кроме соответствующих тематике Сайта (поиск работы, сотрудников,
            получение информации о рынке труда). При этом, Пользователю запрещается
            распространять/передавать любые данные, предоставленные другим Пользователем,
            без письменного разрешения лица, разместившего такие сведения. В том числе,
            Пользователю запрещается использовать e-mail, номер телефона другого
            Пользователя для целей рассылки сообщений, а также для действий, совершаемых
            без ведома или согласия другой стороны.
          </p>
          <p align="center">
            <strong>8. Ответственность сторон</strong>
          </p>
          <p>
            8.1. Стороны несут ответственность за неисполнение или ненадлежащее исполнение
            своих обязательств в соответствии с условиями Соглашения и законодательством
            Российской Федерации.
          </p>
          <p>
            8.2. Сайт предоставляется в состоянии «как есть», без гарантийных обязательств
            или какой-либо обязанности по устранению недостатков, эксплуатационной
            поддержке и усовершенствованию.
          </p>
          <p>
            8.3. Администрация Сайта не несет ответственности за технические перебои в
            работе Сайта. Вместе с тем Администрация Сайта обязуется принимать все
            разумные меры для предотвращения таких перебоев. Администрация Сайта также не
            гарантирует сохранности информации, размещенной на Сайте и возможности
            бесперебойного доступа к Личному кабинету.
          </p>
          <p>
            8.4. Сервисы Сайта в любой момент могут изменяться, дополняться, обновляться,
            менять форму и характер функциональных возможностей без предварительного
            уведомления Пользователя. Администрация Сайта вправе по собственному
            усмотрению прекратить, приостановить функционирование Сервисов без
            предварительного уведомления.
          </p>
          <p>
            8.5. Администрация Сайта не несет ответственности за любые действия
            Пользователя, связанные с использованием предоставленных прав использования
            Сайта; за ущерб любого рода, понесенный Пользователем из-за утраты и/или
            разглашения своих данных либо в процессе использования Сайта.
          </p>
          <p>
            8.6. Администрация Сайта не обязана осуществлять проверку содержания,
            подлинности и безопасности информации, размещаемой Пользователем, а также
            проверку ее соответствия требованиям законодательства и наличия у Пользователя
            необходимого объема прав на ее распространение или использование.
          </p>
          <p>
            8.7. В случае если какое-либо третье лицо предъявляет Администрации Сайта
            претензию в отношении прав на интеллектуальную собственность, иную претензию в
            связи с нарушением Пользователем законодательства, Пользователь обязуется
            компенсировать Администрации Сайта все расходы и потери, оплатить любые
            компенсации и прочие затраты, связанные с такой претензией.
          </p>
          <p>
            8.8. Поскольку идентификация пользователей интернет-сайтов затруднена по
            техническим причинам, Администрация Сайта не отвечает за то, что Пользователи
            Сайта являются действительно теми, за кого себя выдают, и не несет
            ответственности за убытки, причиненные Пользователям или другим лицам в связи
            с этим.
          </p>
          <p>
            8.9. Администрация Сайта не является представителем ни Кандидатов, публикующих
            на Сайте свои Интервью, ни HR, размещающих вакансии, поэтому не может отвечать
            ни за какие договоренности и финансовые обязательства, возникающие между
            Пользователями.
          </p>
          <p>
            8.10. Администрация Сайта не гарантирует Кандидату действительность вакансий,
            размещенных HR на Сайте, а равно любых предложений, сделанных Кандидату с
            помощью Сайта, с использованием контактной информации, находящейся в базе
            данных Сайта.
          </p>
          <p>
            8.11. Администрация Сайта прилагает все возможные усилия для того, чтобы
            избежать несанкционированного использования персональных данных Пользователей,
            однако не несет ответственности за возможное нецелевое использование
            персональных данных Пользователей, произошедшее из-за технических неполадок в
            программном обеспечении, серверах, находящихся вне контроля Администрации
            Сайта либо произошедшее по вине других пользователей или третьих лиц.
          </p>
          <p>
            8.12. Администрация Сайта не несет ответственности за использование (как
            правомерное, так и неправомерное) третьими лицами Интервью, размещенного на
            Сайте, включая его воспроизведение и распространение, осуществленные как в
            рамках Сайта, так и иными возможными способами.
          </p>
          <p align="center">
            <strong>9. Изменение условий Соглашения</strong>
          </p>
          <p>
            9.1. Администрация Сайта оставляет за собой право вносить изменения в текст
            настоящего Соглашения, без специального уведомления об этом Пользователей
            путем публикации новой редакции Соглашения.
          </p>
          <p>
            9.2. Пользователь обязан регулярно отслеживать изменения, вносимые в
            Соглашение. Если Пользователь не согласен с новой редакцией Соглашения, то он
            обязан незамедлительно прекратить использование Сайта. В случае если после
            вступления в действие новой редакции Соглашения Пользователь продолжает
            использовать Сайт, то такой Пользователь тем самым подтверждает свое полное
            согласие с новой редакцией Соглашения.
          </p>
          <p align="center">
            <strong>10. Разрешение споров</strong>
          </p>
          <p>
            10.1. Претензионный порядок досудебного урегулирования споров, вытекающих из
            настоящего Соглашения, является для Сторон обязательным.
          </p>
          <p>
            10.2. Срок рассмотрения претензионного письма составляет 30 дней со дня
            получения последнего адресатом.
          </p>
          <p>
            10.3. Администрация Сайта вправе не рассматривать обращения Пользователя: не
            содержащие информацию и документы, необходимые для рассмотрения обращения;
            содержащие ложную информацию и (или) документы, не обладающими признаками
            достоверности; в отношении вопросов, по которым ранее был направлен ответ
            Пользователю; содержащие оскорбления, угрозы или обращения, изложенные в
            резкой негативной форме.
          </p>
          <p>
            10.4. Все споры, вытекающие из настоящего Соглашения, подлежат рассмотрению в
            суде в соответствии с законодательством РФ.
          </p>
          <p align="center">
            <strong>11. Заключительные положения</strong>
          </p>
          <p>
            11.1. Ничто в Соглашении не может пониматься как установление между
            Пользователем и Администрацией Сайта агентских отношений, отношений по
            совместной деятельности либо каких-то иных отношений, прямо не предусмотренных
            Соглашением.
          </p>
          <p>
            11.2. При заключении, исполнении и расторжении Соглашения Стороны вправе
            использовать электронные документы, удостоверенные простой электронной
            подписью. Простой электронной подписью признается электронная подпись, которая
            посредством использования логина и пароля Пользователя или указанного при
            использовании Сервиса адреса электронной почты Пользователя (ключ электронной
            подписи) подтверждает факт формирования электронной подписи непосредственно
            Пользователем.
          </p>
          <p>
            11.3. Электронные документы, подписанные простой электронной подписью,
            признаются равнозначными документам на бумажных носителях, подписанным
            собственноручной подписью. Администрация Сайта определяет Пользователя,
            которому соответствует простая электронная подпись, по используемому
            Пользователем логину и паролю, указанным при регистрации/или авторизации на
            Сайте, – в случае совершения любых действий по использованию Сайта, либо по
            используемому Пользователем адресу электронной почты – в случае поступления
            Администрации Сайта сообщений с такого адреса. Любые действия, совершенные с
            использованием Учетных данных/электронной почты определенного Пользователя,
            считаются совершенными таким Пользователем.
          </p>
          <p>
            11.4. Соглашение регулируется и толкуется в соответствии с законодательством
            Российской Федерации. Вопросы, не урегулированные настоящим Соглашением,
            подлежат разрешению в соответствии с законодательством Российской Федерации.
            Везде по тексту настоящего Соглашения под термином «законодательство»
            понимается законодательство Российской Федерации.
          </p>
          <p>
            11.5. Если по тем или иным причинам одно или несколько положений настоящего
            Соглашения будут признаны недействительными или не имеющими юридической силы,
            это не окажет влияния на действительность или применимость остальных положений
            Соглашения.
          </p>
          <p>
            11.6. Обращения, предложения и претензии к Администрации Сайта в связи с
            Соглашением и со всеми вопросами по функционированию Сайта, нарушениям прав и
            интересов третьих лиц при его использовании, а также запросы уполномоченных
            законодательством лиц могут быть направлены по реквизитам, указанным в разделе
            12 Соглашения.
          </p>
          <p>
            11.7. Неотъемлемыми частями Соглашения являются:
          </p>
          <p>
            Приложение №1 – Политика конфиденциальности {{ APP_NAME }}.
          </p>
          <p align="center">
            <strong>12. Реквизиты Администрации Сайта</strong>
          </p>
          <p>
            ООО "Бозон"
          </p>
          <p>
            ОГРН: 1187746716563
          </p>
          <p>
            105066, г. Москва, вн.тер.г. Муниципальный Округ
            <br>
            Басманный, ул Доброслободская, д. 7/1 стр. 3, помещ. 3/2
          </p>
          <p>Еmail: <a :href="`mailto:${SUPPORT_EMAIL}`">{{ SUPPORT_EMAIL }}</a></p>
        </VCard>
      </VCol>
    </VRow>
  </VContainer>
</template>

<script>
import { HOME_DOMAIN, APP_NAME, SUPPORT_EMAIL } from '@/helpers/constants';

export default {
  name: 'Agree',
  data() {
    return {
      HOME_DOMAIN,
      APP_NAME,
      SUPPORT_EMAIL,
      pageTitle: `Пользовательское соглашение ${APP_NAME}`,
    };
  },
  metaInfo() {
    return {
      title: this.pageTitle,
    };
  },
  mounted() {
    setTimeout(() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }, 100);
  },
};
</script>
